/**
 * Helpers for curated Project Documents Egnyte folder links.
 */

import {
  EGNYTE_WEB_FILES_BASE,
  PROJECT_DOCUMENT_FOLDER_NAMES,
} from "../constants";

/**
 * Build an Egnyte web UI URL for a filesystem path.
 *
 * @param {string} folderPath - Egnyte path, with or without a leading slash.
 * @returns {string}
 */
export function buildEgnyteWebUrl(folderPath) {
  if (!folderPath) return "";
  const normalized = folderPath.startsWith("/")
    ? folderPath
    : `/${folderPath}`;
  return `${EGNYTE_WEB_FILES_BASE}${normalized}`;
}

/**
 * Build immediate link rows from a resolved job folder path (before stats load).
 *
 * ``T&M RS App`` may live under ``07-PCOs*`` — omit its URL until the backend
 * resolves the real path (avoids a wrong job-root deep-link).
 *
 * @param {string} jobFolderPath - Absolute Egnyte job folder path.
 * @returns {Array<{ name: string, path: string|null, webUrl: string, exists: null, filesCount: null, lastModified: null }>}
 */
export function buildDocumentFolderLinkPlaceholders(jobFolderPath) {
  const base = (jobFolderPath || "").replace(/\/$/, "");
  return PROJECT_DOCUMENT_FOLDER_NAMES.map((name) => {
    // Backend resolves T&M under job root or nested 07-PCOs* parents.
    if (name === "T&M RS App") {
      return {
        name,
        path: null,
        webUrl: "",
        exists: null,
        filesCount: null,
        lastModified: null,
      };
    }
    const path = `${base}/${name}`;
    return {
      name,
      path,
      webUrl: buildEgnyteWebUrl(path),
      exists: null,
      filesCount: null,
      lastModified: null,
    };
  });
}

/**
 * Empty document-folders state for ProjectPageContext.
 *
 * @param {boolean} [isLoading=false] - Whether a load is in progress.
 * @returns {{ path: string|null, webUrl: string|null, folders: Array, isLoading: boolean, statsLoading: boolean, error: string|null }}
 */
export function getEmptyDocumentFoldersState(isLoading = false) {
  return {
    path: null,
    webUrl: null,
    folders: [],
    isLoading,
    statsLoading: false,
    error: null,
  };
}
